import React, { useState } from 'react';
import { EdgeProps, getStraightPath, EdgeLabelRenderer } from 'reactflow';
import { useTheme } from '../../../contexts/ThemeContext';

interface StraightEdgeData {
  type?: string;
  label?: string;
  sourceNodeLabel?: string;
  targetNodeLabel?: string;
}

export const StraightEdge: React.FC<EdgeProps<StraightEdgeData>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  data,
  markerEnd,
  selected,
  source,
  target
}) => {
  const { darkMode } = useTheme();
  const [showTooltip, setShowTooltip] = useState(false);
  
  // Calculate the straight path
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  // Get edge styling
  const getEdgeStyle = () => {
    const baseStyle = {
      strokeWidth: 2,
      fill: 'none',
      ...style
    };

    if (selected) {
      baseStyle.strokeWidth = 3;
      baseStyle.stroke = darkMode ? '#60a5fa' : '#3b82f6';
      baseStyle.filter = 'drop-shadow(0 0 6px rgba(59, 130, 246, 0.5))';
    }

    return baseStyle;
  };

  const edgeStyle = getEdgeStyle();

  return (
    <>
      <path
        id={id}
        style={edgeStyle}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      
      {/* No icons for straight edges - clean minimal look */}
    </>
  );
};
